import styled from 'styled-components';

export const HintBox = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.25rem 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
`;
